<template>
  <div id="footer" class="container-fluid">
    <div class="footer-main">
      <ul>
        <li class="title">
          <img class="footer-logo" :src="imgs" alt="logo" />
          <div class="enterprise">戈公航运</div>
        </li>
        <li>邮箱：kohkongshipping@163.com</li>
        <li>电话：0770-6688899</li>
        <li>地址：防城港市港口区玉石滩大道东侧广西北部湾国际生鲜冷链园区27号楼3层302号房</li>
      </ul>
      <ul>
        <li>
          <img class="footer-code" src="@/assets/img/code.jpg" alt="二维码" />
        </li>
        <li style="text-align: center">扫一扫关注公众号</li>
      </ul>
    </div>
    <p class="copy">
      <span> Copyright &copy; 2024 广西戈公国际航运有限公司 </span>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=45060302000121" rel="noreferrer" target="_blank"> <img src="@/assets/img/icon-beian.png" alt="" />桂公网安备45060302000121</a>
      <a href="https://beian.miit.gov.cn" target="_blank">桂ICP备2024047031号-1</a>
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      imgs: require("@/assets/img/logo_w.png"),
    };
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: rgba(255, 255, 255, 0.65);
  background: #396afc;
  overflow: hidden;
}
.footer-main {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 25px;
  font-size: 12px;
}
.footer-main > ul > li {
  margin-top: 10px;
}
.title {
  height: 40px;
  width: 130px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 25px;
  margin-bottom: 20px;
  color: rgba(255, 255, 255, 1);
}
.title .footer-logo {
  height: 35px;
}
.title .enterprise {
  height: 35px;
  line-height: 35px;
  font-size: 22px;
  font-weight: bold;
}

.footer-code {
  width: 150px;
  height: 150px;
}

.copy {
  font-size: 14px;
  margin: 30px 0 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 30px;
  flex-wrap: wrap;
}
.copy img {
  width: 16px;
  height: 16px;
  margin: 0px 4px;
  display: inline-block;
}
.copy a {
  color: aliceblue;
  display: flex;
  align-items: center;
}
.copy span,
.copy a {
  margin: 0px 4px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
    text-align: center;
  }
}
.sys {
  cursor: pointer;
}
.sys:hover {
  color: #23527c;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue